export default {
    /// <summary>
    /// Mầm non
    /// </summary>
    Kintergarten: 5,

    /// <summary>
    /// Tiểu học
    /// </summary>
    PrimarySchool: 10,

    /// <summary>
    /// Trung học
    /// </summary>
    SecondarySchool: 15,

    /// <summary>
    /// Liên cấp 1,2
    /// </summary>
    InterLevelSchool12: 25,

    /// <summary>
    /// GDTX
    /// </summary>
    ContinuingEducation: 40,

    /// <summary>
    /// Khác
    /// </summary>
    Other: 60,
}